import { isTelegram } from './platform/detector';

// Auth headers getter - will be set by AuthProvider
let authHeadersGetter = null;

/**
 * Set the auth headers getter function
 * Called by App.js after AuthProvider is mounted
 */
export function setAuthHeadersGetter(getter) {
  authHeadersGetter = getter;
}

/**
 * Get auth headers for API requests
 * Works with both Telegram and standalone auth
 */
function getAuthHeaders(chatId = '') {
  if (authHeadersGetter) {
    return authHeadersGetter(chatId);
  }

  // Fallback to Telegram auth (for backward compatibility during migration)
  if (window.Telegram?.WebApp?.initData && window.Telegram.WebApp.initData !== '') {
    return {
      'X-WebApp-Hash': window.Telegram.WebApp.initData,
      'X-WebApp-Chat': chatId || '',
      'X-WebApp-Referer': getReferer()
    };
  }

  // Fallback to stored token (standalone mode)
  const token = localStorage.getItem('auth_token');
  if (token) {
    return {
      'Authorization': `Bearer ${token}`,
      'X-WebApp-Referer': getReferer()
    };
  }

  return {};
}

function getAllowsToWritePM() {
  // In standalone mode, always allow (user is already logged in via Telegram)
  if (!isTelegram) {
    return true;
  }
  return window.Telegram?.WebApp?.initDataUnsafe?.user?.allows_write_to_pm || false;
}

function requestToWritePM() {
  // In standalone mode, always resolve (user logged in via Telegram)
  if (!isTelegram) {
    return Promise.resolve(true);
  }
  if (getAllowsToWritePM()) {
    return Promise.resolve(true);
  }
  return new Promise((resolve, reject) => {
    reportEvent('write_pm_request');
    window.Telegram.WebApp.requestWriteAccess((granted) => {
      if (granted) {
        reportEvent('write_pm_granted');
        resolve(true);
      } else {
        reportEvent('write_pm_rejected');
        reject(false);
      }
    });
  });
}

function getTimezoneOffsetInSeconds() {
  const date = new Date();
  const offsetInMinutes = date.getTimezoneOffset();
  const offsetInSeconds = offsetInMinutes * 60;
  return offsetInSeconds;
}

function reportEvent(eventName, eventParams) {
  fetch('/api/statevents/' + eventName, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify(eventParams || {})
  });
}

let firstLoadedStatic;
function applyStaticVersion(newStatic) {
  if (!newStatic || newStatic < 1) {
    return;
  }
  if (firstLoadedStatic === undefined) {
    firstLoadedStatic = newStatic;
    return;
  }
  if (newStatic > firstLoadedStatic) {
    try {
      window.location.reload(true);
    } catch (e) {
      try {
        const curLoc = window.location.href.toString();
        window.location = curLoc.replace(/\?\d+(#|$)/, '?' + newStatic + '$1');
      } catch (e) {}
    }
  }
}

let referer = null;
function getReferer() {
  return referer;
}
function setReferer(refererId) {
  referer = refererId;
}

export {
  applyStaticVersion,
  getAllowsToWritePM,
  requestToWritePM,
  reportEvent,
  getTimezoneOffsetInSeconds,
  getReferer,
  setReferer,
  getAuthHeaders
};
